import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Pythontemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Python",
        content: [
        "History and background of Python",
        "Installing Python and setting up the environment",
        "Data types, variables, and operators",
        "Basic input/output and control structures"
        ]
        },
        {
        title: "Functions and Modules",
        content: [
        "Creating and using functions",
        "Passing arguments and returning values",
        "Modules and packages",
        "Working with built-in and third-party modules"
        ]
        },
        {
        title: "Data Structures",
        content: [
        "Lists, tuples, and dictionaries",
        "Strings and regular expressions",
        "Sets and frozen sets",
        "Collections module"
        ]
        },
        {
        title: "Object-Oriented Programming",
        content: [
        "Classes and objects",
        "Inheritance and polymorphism",
        "Abstract classes and interfaces",
        "Exceptions and error handling"
        ]
        },
        {
        title: "File Handling and I/O Operations",
        content: [
        "Reading and writing files",
        "Working with CSV and JSON files",
        "Byte streams and binary files",
        "Using context managers"
        ]
        },
        {
        title: "Web Development with Python",
        content: [
        "Overview of web development and HTTP",
        "Web frameworks (e.g. Flask, Django)",
        "HTML, CSS, and JavaScript basics",
        "Working with databases (e.g. SQLite, MySQL)"
        ]
        },
        {
        title: "Data Analysis and Visualization with Python",
        content: [
        "NumPy and Pandas for data manipulation",
        "Data visualization with Matplotlib and Seaborn",
        "Data cleaning and preprocessing",
        "Machine learning basics"
        ]
        },
        {
        title: "Testing and Debugging",
        content: [
        "Unit testing and test-driven development",
        "Debugging techniques and tools",
        "Using the Python debugger",
        "Best practices for testing and debugging"
        ]
        },
        {
        title: "Concurrency and Parallelism",
        content: [
        "Introduction to concurrency and parallelism",
        "Threads and processes in Python",
        "Synchronization and communication",
        "Using the multiprocessing and threading modules"
        ]
        },
        {
        title: "Network Programming",
        content: [
        "Networking basics (e.g. TCP/IP, sockets)",
        "Client-server architecture",
        "Working with HTTP requests and responses",
        "Developing networked applications"
        ]
        },
        {
        title: "Python for Automation and Scripting",
        content: [
        "Using Python for automation and scripting",
        "Working with system resources (e.g. files, directories)",
        "Automating tasks with cron and scheduling",
        "Interacting with the operating system"
        ]
        },
        {
        title: "Advanced Topics",
        content: [
        "Decorators and metaclasses",
        "Generators and coroutines",
        "Context managers and the with statement",
        "Using C extensions and embedding Python"
        ]
        }
    ]

    const faqData = [
      {
        question: 'What is Python and why should I learn it?',
        answer:
          'Python is a versatile, high-level programming language known for its simplicity, readability, and vast range of applications. Learning Python opens doors to careers in web development, data analysis, machine learning, automation, and more. Its clean syntax and beginner-friendly nature make it an excellent choice for those new to coding',
      },
      {
        question: 'What kind of support is available during the Python course?',
        answer:
          'You will have access to experienced Python instructors who will provide personalized guidance, code reviews, and support throughout the course. We also have an active student community forum where you can collaborate and seek assistance',
      },
      {
        question: 'What career opportunities are available after the Python course?',
        answer:
          'After completing our Python course, you will be qualified for roles such as Python Developer, Data Analyst, Machine Learning Engineer, Web Developer, Automation Engineer, and many more. Python has applications in diverse fields, providing you with a wide range of career paths'
        
        },
      {
        question: 'Will I learn to build different types of applications with Python?',
        answer:
          'Yes, our Python course covers building various applications, including web applications, data analysis tools, machine learning models, automation scripts, and more. You will gain exposure to different Python frameworks and libraries'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To enroll in our beginner-friendly Python course and kickstart your Python Training journey, no prior programming experience is required. Our comprehensive Python course is designed for learners of all backgrounds, including students, professionals seeking career transitions, or anyone passionate about exploring the world of coding. With a focus on hands-on learning and real-world applications, we'll guide you through the fundamentals of Python programming from scratch. Basic computer literacy skills, such as using a text editor and navigating the file system, are recommended but not mandatory. Throughout the Python course, you'll master core concepts like variables, data types, functions, and object-oriented programming, empowering you to build a strong foundation for further growth in areas like web development, data analysis, machine learning, and more"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the ever-evolving realm of computer programming, Python stands as a versatile and dynamic language, revered for its adaptability and multifaceted capabilities. This powerhouse programming language finds its application in diverse domains, from web development to data analysis, task automation, and beyond. Python's unique trait lies in its general-purpose nature, allowing it to address a wide array of challenges without being confined to a specific niche. "/> 
           */}
          <NewMainsec rating='4.9' students={"490"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the ever-evolving realm of computer programming, Python stands as a versatile and dynamic language, revered for its adaptability and multifaceted capabilities. This powerhouse programming language finds its application in diverse domains, from web development to data analysis, task automation, and beyond. Python's unique trait lies in its general-purpose nature, allowing it to address a wide array of challenges without being confined to a specific niche. "/>
           
            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Learn the fundamentals of Python programming with our comprehensive Python ${this.props.location1}. At Learnsoft.org, we offer top-notch Python courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Python programming principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Python or looking to expand your skillset, Learnsoft.org's Python ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Python journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Python course covers a wide range of topics, including data structures, algorithms, and programming concepts. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Python programming. By the end of the course, you will be able to write efficient and effective Python code for your own projects."} />
 		</section>

 <Batchtime title={this.props.title} fees="20,999" offer="12,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>         
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="Java" coupath2="java" cou3='R Programming' coupath3='rprogram' cou10='Full Stack Developer' coupath10='full-stack-developer' cou6='AngularJS' coupath6='angularjs' cou9='Front End Developer' coupath9='front-end-developer'
          cou5='ReactJS' coupath5='reactjs' cou='JavaScript' coupath='javascript' cou7='GoCD' coupath7='gocd'
          cou1='DevOps' coupath1='devops' cou8='flutter' coupath8='flutter'  cou4='Go' coupath4='go' />
      </>
    );
  }
}
